export default __webpack_public_path__ + "static/media/cbbSala4.2040084b.jpg";